import type { SVGProps } from 'react';

const SvgTerms = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 19H7c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v7c0 .55.45 1 1 1s1-.45 1-1V6c0-1.65-1.35-3-3-3H7C5.35 3 4 4.35 4 6v12c0 1.65 1.35 3 3 3h3c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M9 9h4c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1m0 4h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1m1 2H9c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1m10.71 1.29a.996.996 0 0 0-1.41 0l-3.29 3.29-1.29-1.29a.996.996 0 1 0-1.41 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29l4-4a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgTerms;
